import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CredentialsSelectComponent} from './credentials-select.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';


@NgModule({
  declarations: [CredentialsSelectComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatChipsModule,
    MatIconModule,
  ],
  exports: [CredentialsSelectComponent]
})
export class CredentialsSelectModule {
}
